<simpayx-header></simpayx-header>

<ion-header class="ion-no-border" mode="ios">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button>
        <ion-icon name="person-circle-outline" class="menu-icon"></ion-icon>
      </ion-menu-button>
    </ion-buttons>
    <ion-title class="header-title">Login</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true">
  <simpayx-shared-login
    [pageDetails]="pageDetails"
    (isLoginSuccess)="loginSuccess($event)"
    *ngIf="!isLoggedIn"
  ></simpayx-shared-login>
</ion-content>
